import classNames from 'classnames';
import './styles/tile.css';

interface TileProps {
  value: string | number;
  id?: string;
  small?: boolean;
  medium?: boolean;
  large?: boolean;
  bonus?: boolean;
  green?: boolean;
  red?: boolean;
  blue?: boolean;
  yellow?: boolean;
  purple?: boolean;
  pink?: boolean;
  galaxy?: boolean;
  fire?: boolean;
  ice?: boolean;
  halloween?: boolean;
  christmas?: boolean;
  secondary?: boolean;
  titleSize?: boolean;
  noTransition?: boolean;
  onClick?: () => void;
}

function Tile(props: TileProps) {
  const {
    value,
    id,
    small,
    medium,
    large,
    bonus,
    green,
    yellow,
    red,
    blue,
    purple,
    pink,
    galaxy,
    fire,
    ice,
    // halloween,
    // christmas,
    secondary,
    titleSize,
    noTransition,
    onClick,
  } = props;
  const tileClass = classNames('tile', {
    'tile-small': small,
    'tile-medium': medium,
    'tile-large': large,
    'tile-empty': value === '',
    'tile-bonus': bonus,
    'tile-green': green,
    'tile-red': red,
    'tile-blue': blue,
    'tile-purple': purple,
    'tile-yellow': yellow,
    'tile-pink': pink,
    'tile-found-galaxy': galaxy,
    'tile-found-fire': fire,
    'tile-found-ice': ice,
    // 'tile-found-halloween': halloween,
    // 'tile-found-christmas': christmas,
    'no-transition': noTransition,
    'tile-secondary': secondary,
    'tile-title': titleSize,
  });
  return (
    <div onClick={onClick} className={tileClass} id={id}>
      {value}
    </div>
  );
}

export default Tile;
